import { Product, ProductTable } from "@/types/system-setting/product";
import { apiSlice } from "@/redux/apiSlice";

interface ProductQuery {
  query: string;
  org_id: number;
}
interface updateResponse {
  status: number;
  detail: string;
}
export const Products = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getAllProducts: builder.query<ProductTable, ProductQuery>({
        query: (searchCretiria) => ({
          url: `/products?${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          providesTags: ["Product"],
        }),
      }),
      addProduct: builder.mutation<Product, Product>({
        query: (productData) => ({
          url: `/products`,
          method: "POST",
          body: productData,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["Product"],
      }),
      updateProduct: builder.mutation<Product, Product>({
        query: ({ id, ...productData }) => ({
          url: `/products/${id}`,
          method: "PUT",
          body: productData,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: ["Product"],
      }),
      deleteProduct: builder.mutation<Product, number>({
        query: (product_id) => ({
          url: `/products/${product_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Product"],
      }),
      getProductById: builder.query<Product, number>({
        query: (product_id) => ({
          url: `/products/${product_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Product"],
      }),
    };
  },
});

export const {
  useGetProductByIdQuery,
  useGetAllProductsQuery,
  useAddProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
} = Products;
